var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_414",
    "data-name": "Union 414",
    d: "M10.083,21.084V19.251a.917.917,0,1,1,1.833,0v1.833a.917.917,0,0,1-1.833,0Zm7.4-2.3-1.3-1.3a.917.917,0,0,1,1.3-1.3l1.3,1.3a.917.917,0,1,1-1.3,1.3Zm-14.263,0a.916.916,0,0,1,0-1.3l1.3-1.3a.916.916,0,1,1,1.3,1.3l-1.3,1.3a.914.914,0,0,1-1.3,0ZM5.5,11A5.5,5.5,0,1,1,11,16.5,5.508,5.508,0,0,1,5.5,11Zm13.751.916a.917.917,0,1,1,0-1.833h1.833a.917.917,0,0,1,0,1.833Zm-18.334,0a.917.917,0,1,1,0-1.833H2.751a.917.917,0,0,1,0,1.833Zm15.265-6.1a.918.918,0,0,1,0-1.3l1.3-1.3a.917.917,0,0,1,1.3,0,.914.914,0,0,1,0,1.3l-1.3,1.3a.916.916,0,0,1-1.3,0Zm-11.659,0-1.3-1.3a.916.916,0,0,1,1.3-1.3l1.3,1.3a.916.916,0,1,1-1.3,1.3Zm5.561-3.067V.917a.917.917,0,1,1,1.833,0V2.751a.917.917,0,0,1-1.833,0Z",
    fill: "#474b4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchTheme);
export default __webpack_public_path__ + "static/media/switch_theme.7ebb519e48dde2955fa2d3a704870653.svg";
export { ForwardRef as ReactComponent };